<template>
  <div v-loading="loading" class="log-wrapper">
    <div class="basic-setting">
      <Top title="数据更新日志">
      </Top>
      <!-- 表格 -->
      <el-table ref="table" v-loading="loading"
                :data="tableData" class="table" empty-text="暂无数据">
        <el-table-column label="更新时间" prop="createdTime" width="250px"></el-table-column>
        <el-table-column label="更新内容" prop="operation" min-width="146px">
          <template v-slot="scope">
            <el-tooltip effect="dark" :content="scope.row.operation" placement="top-start" :open-delay="500">
              <div class="row-str">{{ scope.row.operation }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operatorName" width="100px"></el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[15, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListMixin from 'src/views/mixins/list'
import Top from '@/components/common/tableTop'
import { getCommonLogsApi } from './fetch'
export default {
  name: 'DataUpdatedLog',
  components: {
    Top,
  },
  mixins: [ListMixin],
  data () {
    return {
      filterForm: {
        logType: 1,
      },
      getListApi: getCommonLogsApi,
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.log-wrapper{
  overflow: auto;
}
.basic-setting{
  padding: 0 40px 40px;
}
.row-str{
  @include ellipsis(1);
}
</style>
